import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import { Link } from "react-router-dom";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import ReportCardPeriod from "./ReportCardPeriod";

class FileRecordClass extends Component{

    state = {
        input : [],
        printReportCard : false
    }
        
    handleInput = (e) => {

        var data = [];
        var input = this.state.input;
        this.setState({
            input : []
        })

        var reportCart =  e.target.value;
        var count = input.some(item => reportCart == item)
        if(count)
        {
            data = input.filter(item => item != reportCart);
        }
        else{
            data = input;
            data.push(reportCart)
        }
        
        this.setState({
            input : data
        })
    }

    printReportCard_ = () => {
        this.setState({
            printReportCard : !this.state.printReportCard
        })
    }

    render(){
        
        var  max=0, note=0, note_ = 0, max_ = 0, pourcentage = 0;
        max=0;
        note=0
        return(
                <li className="widget-todo-item list-group-item mt-4 shadow border rounded-3">
                <div
                    className="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50 overflow-hidden">
                    <div className="widget-todo-title-area d-flex align-items-center">
                        <FeatherIcon icon="codesandbox" className='cursor-move'></FeatherIcon>
                        
                        <label htmlFor={this.props.section.id}><span className="widget-todo-title ml-50 fw-bold">{this.props.sectionclasse?.class.short_entitled_class} <span className="text-primary">{this.props.sectionclasse?.title}</span>  {this.props.section.short_entitled_section} </span></label>
                    </div>
                    <div className="widget-todo-item-action d-flex align-items-center">
                        <div className="text-end mb-2 mb-md-0">
                            <div className="btn-group me-2">
                                <ReactToPrint
                                    trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                                    content={() =>  this.componentRef_}
                                />
                            </div>
                        </div>
                        {this.props.section.short_entitled_section} <FeatherIcon icon="list" size="16" className='cursor-move text-dark'></FeatherIcon>
                    </div>
                </div>
                <div>
                <div className="table-responsive m-2 " ref={val_ => (this.componentRef_ = val_)}>
                    <Headerpdf />
                    <div className="text-center h6">
                        <label htmlFor={this.props.section.id}><span className="widget-todo-title ml-50 fw-bold">Resultat {this.props.sectionclasse?.class.short_entitled_class} <span className="text-primary">{this.props.sectionclasse?.title}</span>  {this.props.section.entitled_section}</span></label>
                    </div>
                    <table className="table table-striped table-sm">
                        <thead>
                            <tr>
                                <th>Place</th>
                                <th scope="col">Matr</th>
                                <th scope="col">Nom et post nom</th>
                                <th scope="col">Pourcent</th>
                                <th scope="col">Année</th>
                                <th scope="col "><span className="">Obs</span> </th>
                            </tr>
                        </thead>
                        <tbody>
                             
                            {
                                this.props.sectionclasse?.students.filter(student => student.status == 1 || student.status == 2).sort((a, b) => ( ( a.purcent) < (b.purcent) ? 1 : -1 ) ).map((student, index) => {
                                    note += student.studentsuccess
                                    max += student.studentmax
                                    note_ = 0
                                    max_ = 0
                                    student?.reportcards?.map((reportcard) =>{
                                        note_ += parseFloat(reportcard.note || 0)
                                        max_ += parseFloat(reportcard.sectionclasselesson?.max_evaluation || 0)
                                    })
                                    pourcentage += student?.purcent >= 50 ? 1 : 0 
                                    var last_name = student.user ? student.user.last_name : "";
                                    var first_name = student.user ? student.user.first_name : "";
                                    var family_name = student.user ? student.user.family_name : "";
                                    return(
                                        <tr key={student.id}>
                                            <td> { index+1 }</td>
                                            <td>
                                                <Link to={"/students/"+student.id}  className={ student.purcent >= 50 ? "text-primary text-decoration-none" : "text-danger text-decoration-none" } >
                                                    { student.matricule }
                                                </Link>
                                             </td>
                                            <td>
                                                {/* <img src={student.user && (student.user.avatar)} className="rounded img-fluid" title={(first_name +" "+ last_name)} width={student.user && (student.user.avatar && ("30"))} /> */}
                                                 {student.user && (last_name +" "+ family_name +" "+ first_name)}
                                            </td>
                                            <td>{ student.purcent > 0 ? ((student.purcent).toFixed(1)) + "%" : ""}</td>
                                            <td>{ student.year?.year}</td>
                                            <td className="table_action"><input type={"checkbox"} onChange={this.handleInput}  value={ student.id } className="rounded rounded table_action" /></td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <th colSpan={2}></th>
                                <th>Moyenne</th>
                                <th>{ max > 0 ? (((note * 100 ) / max).toFixed(1) ) + "%" : "" }</th>
                                <th colSpan={2} className="">{pourcentage}/{this.props.sectionclasse?.students?.length}élèves soit { pourcentage > 0 ? ((pourcentage *100) / this.props.sectionclasse?.students?.length)?.toFixed(1) : '' }%</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {
                    this.state.input.length > 0 && (
                        <div>
                            <button className="btn btn-primary btn-sm" onClick={() => this.printReportCard_() }>Imprimer la selection</button>
                        </div>
                    )
                }
                </div>
                {
                    this.state.input.length > 0 && (
                        <ReportCardPeriod
                            isModal={this.state.printReportCard} 
                            formData={this.state.input}
                            showModal={this.printReportCard_}
                        />
                    )
                }
            </li>
            )
    }
}
export default FileRecordClass